<template>
    <div class="enviados">
        <vs-row v-if="tablaSalida" >
            <vs-col sm="12" lg="4" class="ml-auto">
                <vs-input v-model="search" placeholder="Buscar">
                    <template #icon>
                    <i class="fas fa-search"></i>
                    </template>
                </vs-input>
            </vs-col>
        </vs-row>
        <vs-table v-if="tablaSalida" class="table-responsive" v-dragscroll="{ target: '.vs-table', active: true }">
            <!-- <template #thead>
            <vs-tr>
                <vs-th>
                Name
                </vs-th>
                <vs-th>
                Email
                </vs-th>
                <vs-th>
                Id
                </vs-th>
            </vs-tr>
            </template> -->
            <template #tbody>
            <vs-tr
                :key="i"
                v-for="(tr, i) in $vs.getSearch(enviados, search)"
                :data="tr"
                style="border-bottom: 1px solid #cccc; cursor:pointer"
            >
                <vs-td v-if="tr.mail.sended === 1" @click="getShowReenviar(tr, i)">
                    <span style="text-transform: capitalize;">{{ tr.from_name }}</span>
                </vs-td>
                <vs-td v-if="tr.mail.sended === 1" @click="getShowReenviar(tr, i)">
                    <strong> {{ tr.mail.subject }} </strong>
                </vs-td>
                <!-- <vs-td @click="getShowReenviar(tr, i)">
                 <md-chip class="mb-1 fontMedium mini-chip col-blue"> <strong>{{ tr.ciclo_escolar.nombre }}</strong></md-chip>
                </vs-td> -->
                <vs-td  v-if="tr.mail.sended === 1" @click="getShowReenviar(tr, i)">
                    <md-chip  @click="getShowReenviar(tr, i)" class="mb-1 fontMedium mini-chip col-green"> <strong>{{ tr.sendedmails.length }} destinatarios</strong></md-chip>
                </vs-td>
                <vs-td v-if="tr.mail.sended === 1" @click="getShowReenviar(tr, i)">
                    {{ getDate(tr) }}
                </vs-td>
                <vs-td v-if="tr.mail.sended === 1">
                    <md-progress-spinner :md-diameter="30" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
                </vs-td>
            </vs-tr>
            </template>
            <template #notFound>
                No hay correos en envío.
            </template>
        </vs-table>
        <salida v-if="salidas" :info="info"></salida>
    </div>
</template>

<script>
import salida from './correo-salida.vue'
export default {
    props: [
        'enviados',
        'salidaInfo'
    ],
    data() {
        return{
            amount: 25,
            buffer: 40,
            info: [],
            tablaSalida: true,
            salidas: false,
            search: ''
        }
    },
    components: {
        salida
    },
    created(){
        this.getDate()
    },
    methods:{
        getShowReenviar(tr, i){
            this.tablaSalida = false
            this.salidas = true
            this.info = tr
        },
        getDate(info){
            if(info){
                const f = new Date(info.mail.updated_at);
                const result = f.toLocaleString();
                return result
            }
        }
    },
    watch:{
        salidaInfo(){
            this.tablaSalida = true
            this.salidas = false
            this.$emit('reAbrirSalida', true);
        }
    }
}
  </script>

<style>
    .enviados .table-responsive{
        margin-top: 3% !important;
    }
    .hasOpenLoading .box-loading {
  opacity: 0;
  transform: scale(0.7);
}
.box-loading {
  width: 120px;
  height: 120px;
  position: relative;
  margin: 5px;
  border-radius: 20px;
  box-shadow: 0px 10px 20px -10px rgba(0,0,0,0.07);
  overflow: hidden;
  cursor: pointer;
  transition: all 0.25s ease;
}
.box-loading:hover {
  transform: translate(0, -5px);
  box-shadow: 0px 15px 20px -10px rgba(0,0,0,0.09);
}
.box-loading .vs-loading {
  padding: 0px;
}
</style>
<style scoped>
    .vs-table{
        overflow-x: none;
    }

    .vs-table__tbody{
        vertical-align: top !important;
    }

    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }

    .col-purple{
        color: purple;
        background: rgb(232, 218, 239);
    }

    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }

    .col-gray{
        color: #5F6A6A;
        background: rgb(242, 243, 244);
    }

    .col-pink{
        color: #F08080;
        background: rgb(255, 236, 236);
    }

    .col-brown{
        color: #784212;
        background: rgb(250, 229, 211);
    }

    .md-chip{
        height: 24px !important;
        line-height: 24px !important;
    }
</style>